import classNames from 'classnames';
import { bool, func, oneOf, string } from 'prop-types';

import style from './LootBoyButton.module.scss';

const LENGTH_LIMIT = 15;

export const COLORS = {
  GREEN: 'green',
  WHITE: 'white',
  RED: 'red',
  ORANGE: 'orange',
  BLUE: 'blue',
};

const LootBoyButton = ({
  className,
  disabled,
  onClick,
  title,
  type,
  scaleTitle,
  wrap,
}) => {
  let fontSize;
  if ((scaleTitle || wrap) && title.length > LENGTH_LIMIT) {
    fontSize = `${0.95 * (LENGTH_LIMIT / title.length)}em`;
  }
  if (wrap && title.length > 2 * LENGTH_LIMIT) {
    fontSize = `${0.95 * (LENGTH_LIMIT / title.length) * 2}em`;
  }
  return (
    <button
      className={classNames(style.lootBoyButton, style[type], className)}
      onClick={onClick}
      type="button"
      disabled={disabled}
    >
      <span
        className={classNames(style.lootBoyButtonContent, {
          [style.wrap]: wrap,
        })}
        style={{ fontSize }}
      >
        {title}
      </span>
    </button>
  );
};

LootBoyButton.propTypes = {
  className: string,
  disabled: bool,
  onClick: func,
  title: string.isRequired,
  type: oneOf(Object.values(COLORS)),
  scaleTitle: bool,
  wrap: bool,
};

export default LootBoyButton;
